"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNotificationSettingTypes = exports.NotificationSettingType = void 0;
var NotificationSettingType;
(function (NotificationSettingType) {
    NotificationSettingType["CUSTOMER_INVOICE_ON_HOLD"] = "customer_invoice_on_hold";
    NotificationSettingType["CUSTOMER_INVOICE_NEEDS_APPROVAL"] = "customer_invoice_needs_approval";
    NotificationSettingType["CUSTOMER_INVOICE_FAILED_TO_SEND"] = "customer_invoice_failed_to_send";
    NotificationSettingType["PAYROLL_NEEDS_SUPPLEMENTAL_PAY"] = "payroll_needs_supplemental_pay";
    NotificationSettingType["RATE_CHANGES"] = "rate_changes";
})(NotificationSettingType = exports.NotificationSettingType || (exports.NotificationSettingType = {}));
const getNotificationSettingTypes = () => Object.freeze({
    CUSTOMER_INVOICE_ON_HOLD: 'customer_invoice_on_hold',
    CUSTOMER_INVOICE_NEEDS_APPROVAL: 'customer_invoice_needs_approval',
    CUSTOMER_INVOICE_FAILED_TO_SEND: 'customer_invoice_failed_to_send',
    PAYROLL_NEEDS_SUPPLEMENTAL_PAY: 'payroll_needs_supplemental_pay',
    RATE_CHANGES: 'rate_changes',
});
exports.getNotificationSettingTypes = getNotificationSettingTypes;
//# sourceMappingURL=notificationSettings.js.map